import * as React from 'react'
import {
  useFormikContext,
} from 'formik'
import {
  useEffect,
} from 'react'
import ReactGA from 'react-ga4'
import {
  FormInput, Button,
  ProgressBar,
} from '@pareto-engineering/design-system/'
import styleNames from '@pareto-engineering/bem/exports'
import useLockBodyScroll from '@pareto-engineering/utils/src/hooks/useLockBodyScroll'
import BlurOverlay from '@pareto-engineering/design-system/src/ui/a/BlurOverlay/BlurOverlay'
import { Navigator, useConversionForm } from 'modules/components'

import './styles.scss'

const baseClassName = styleNames.base
const componentClassName = 'fixed-conversion-inner'
const wrapperClassName = 'fixed-conversion-wrapper'
const isClient = !(typeof window === 'undefined')
const originalStyle = isClient ? window.getComputedStyle(document.body).overflow : undefined

const FixedConversionForm = ({
  id,
  className: userClassName,
  style,
  close,
  progressBarColor,
  disableNav,
  overrideGridProps,
}) => {
  const {
    visibleInputFields,
    Content,
    currentSection,
    progressPercentage,
  } = useConversionForm()

  const { values, status } = useFormikContext()

  const contentLayoutClass = currentSection.display === 'column'
    ? 'content column'
    : 'content'
  return (
    <div
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
        'grid',
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
    >
      {
        !disableNav && (
          <ProgressBar
            attached
            color={progressBarColor}
            progress={progressPercentage}
            height=".5em"
          />
        )
      }

      <Button isSimple onClick={close} className="close start-8 span-1 md-start-13 md-span-1">
        <span className="icon">Y</span>
      </Button>
      <div className={overrideGridProps ? `${overrideGridProps} ${contentLayoutClass}` : `start-1 span-8 md-start-5 md-span-6 ${contentLayoutClass}`}>
        <div className="description-section md-start-5 md-span-6">
          <p className="h3">{currentSection.title}</p>
          {currentSection.subtitle}
        </div>
        <div className="interactive-section">
          {
          visibleInputFields?.map((input) => (
            <FormInput
              {...input}
              key={input.name}
            />
          ))
        }
          { Content && Content(values) }
          {currentSection.posttext
            && (
            <div className="s-1 post-text span-grid">
              {currentSection.posttext }
            </div>
            )}
          {status && (<div className="relay-error span-grid">{status}</div>)}
        </div>
      </div>
      {!disableNav && <Navigator className="navigator-section start-1 span-8 md-start-2 md-span-12" />}
      {currentSection.desktopBottomBannerText && (
      <div className="bottom-banner no-wrap">
        <span className="hide-on-desktop">{currentSection.mobileBottomBannerText || currentSection.desktopBottomBannerText}</span>
        <span className="hide-on-mobile">{currentSection.desktopBottomBannerText}</span>
      </div>
      )}
    </div>
  )
}

const FixedConversionFormWrapper = ({
  className,
  desktopLaunchText,
  mobileLaunchText,
  desktopButtonText,
  mobileButtonText,
  ...otherProps
}) => {
  const {
    isOpen, setIsOpen, currentSection, currentSectionIndex,
  } = useConversionForm()

  useLockBodyScroll(isOpen, originalStyle)

  const gaBaseData = {
    category:'Conversion Form Event',
    label   :`Step ${currentSectionIndex + 1}: ${currentSection.title}`,
  }

  const sendGAEvent = (action) => {
    ReactGA.event({
      action,
      ...gaBaseData,
    })
  }

  useEffect(() => {
    if (isOpen) {
      sendGAEvent('Opened Conversion Form')
    }
  }, [isOpen])

  return (
    <>
      <BlurOverlay blur={isOpen}>
        <FixedConversionForm
          className={[
            className,
            isOpen ? 'open' : 'close',
          ]
            .filter((e) => e)
            .join(' ')}
          close={() => {
            setIsOpen(false)
            sendGAEvent('Closed Conversion Form')
          }}
          {...otherProps}
        />
      </BlurOverlay>

      {!isOpen && (
        <div className={[
          baseClassName,
          wrapperClassName,
          'grid',
          'span-grid',
        ]
          .filter((e) => e)
          .join(' ')}
        >
          <div className="launch-text start-1 span-5 md-start-2 md-span-6">
            <p className="hide-on-mobile">{desktopLaunchText || mobileLaunchText}</p>
            <p className="hide-on-desktop">{mobileLaunchText}</p>
          </div>
          <Button isCompact className="launch-button start-6 span-3 md-start-12 md-span-2 x-interactive" onClick={() => setIsOpen(!isOpen)}>
            <span className="hide-on-mobile">{desktopButtonText || mobileButtonText}</span>
            <span className="hide-on-desktop">{mobileButtonText}</span>
          </Button>
        </div>
      )}
    </>
  )
}

FixedConversionForm.defaultProps = {
  progressBarColor:'interactive',
}

FixedConversionFormWrapper.defaultProps = {
  mobileLaunchText:'Ready to launch your solution?',
  mobileButtonText:'Get Results',
}

export default FixedConversionFormWrapper
